// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.work-merge-vote-popup-wrapper {
  width: 54.4rem;
}
.work-merge-vote-popup-wrapper h3 {
  font-size: 28px;
}
.work-merge-vote-popup-wrapper .buttons {
  margin-top: 3rem;
  gap: 2.4rem;
}
.work-merge-vote-popup-wrapper .buttons > * {
  flex: auto;
}`, "",{"version":3,"sources":["webpack://./src/kit/components/Popups/ConfirmationPopup/WorkMergeVoteConfirmationPopup/index.scss"],"names":[],"mappings":"AAAA;EACE,cAAA;AACF;AACE;EACE,eAAA;AACJ;AAEE;EACE,gBAAA;EACA,WAAA;AAAJ;AAEI;EACE,UAAA;AAAN","sourcesContent":[".work-merge-vote-popup-wrapper {\n  width: 54.4rem;\n\n  h3 {\n    font-size: 28px;\n  }\n\n  .buttons {\n    margin-top: 3rem;\n    gap: 2.4rem;\n\n    & > * {\n      flex: auto;\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
